import React from 'react';
import { t } from 'i18next';
import CrmEntityTypeTable from './CrmEntityTypeTable';

export default function CrmContactTypes() {
  return (
    <CrmEntityTypeTable
      endpoint="crm/contact-types"
      title={t('ContactType')}
      addLabel={`${t('Create')} ${t('ContactType')}`}
    />
  );
}
